module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_0.2e9bdd9f.png";